module.exports = __webpack_public_path__ + "img/手淘其它商品详情页-示例图.4a7a4769.jpeg";